module.exports = __webpack_public_path__ + "static/media/arcoSole.d424e7fd.svg";